module.exports = __webpack_public_path__ + "static/media/Samira_0.0fe75e4a.jpg";